import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'

const FileList = ({ files, onRemove }) => {
  if (!files || files.length === 0) {
    return <></>
  }

  return (
    <List dense>
      {files.map((file, index) => (
        <ListItem
          key={index}
          secondaryAction={
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={(e) => {
                e.stopPropagation()
                onRemove(index)
              }}
            >
              <DeleteIcon />
            </IconButton>
          }
        >
          <ListItemText primary={file.path} />
        </ListItem>
      ))}
    </List>
  )
}

export default FileList
